export default {"src":"/_next/static/media/chevron-right-white.f047dfe4.svg","height":18,"width":12,"blurWidth":0,"blurHeight":0};